import { FC } from 'react';
import { Box, Button, Typography, Divider, Skeleton } from '@mui/material';
import ReusableModal from '../common/Modal';

interface TMBillBrandInfoModalProps {
  open: boolean;
  onClose: () => void;
  storeInfo: {
    outletName: string;
    brandName: string;
    address: string;
    tmBillBrandShortName: string;
    storeId: string;
  };
  isLoading?: boolean;
  isSubmitting?: boolean;
  handleMenuGeneration?: () => void;
}

const TMBillBrandInfoModal: FC<TMBillBrandInfoModalProps> = ({
  open,
  onClose,
  storeInfo,
  isLoading = false,
  isSubmitting = false,
  handleMenuGeneration,
}) => {
  return (
    <>
      <ReusableModal open={open} onClose={onClose} title="Verify Store Details">
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {isLoading ? (
            // Show skeletons when loading
            <>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Skeleton width={180} height={30} />
                <Skeleton width="100%" height={30} />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Skeleton width={180} height={30} />
                <Skeleton width="100%" height={30} />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Skeleton width={180} height={30} />
                <Skeleton width="100%" height={30} />
              </Box>
            </>
          ) : (
            <>
              <InfoRow label="Outlet Name :" value={storeInfo.outletName} />
              <InfoRow label="Brand Name :" value={storeInfo.brandName} />
              <InfoRow label="Address :" value={storeInfo.address} />
            </>
          )}

          <Divider />

          <Button
            fullWidth
            variant="contained"
            onClick={handleMenuGeneration}
            disabled={isLoading || isSubmitting}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              height: '48px',
              fontSize: '16px',
              fontWeight: 500,
            }}
          >
            {isSubmitting ? 'Processing...' : 'Continue'}
          </Button>
        </Box>
      </ReusableModal>
    </>
  );
};

// Helper component for displaying label-value pairs
const InfoRow: FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    }}
  >
    <Typography
      sx={{
        fontFamily: 'DM Sans',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '100%',
        color: '#6B6F80',
        width: '120px',
        minWidth: '120px',
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        flex: 1,
        fontSize: '14px',
        color: 'text.primary',
        fontWeight: 400,
      }}
    >
      {value}
    </Typography>
  </Box>
);

export default TMBillBrandInfoModal;
